import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  checkbox: {
    width: '100%'
  },
  select: {
    width: '100%'
  },
  dateTimePicker: {
    width: '100%'
  },
  textField: {
    marginBottom: 24
  }
}))

export default useStyles
